import { selectBalancingBuilding } from "../balancingSelectors/selectBalancingBuildings";
import { selectBalancingPackageById } from "../balancingSelectors/selectBalancingPackages";
import { selectPoolRewardsIconInfo } from "../balancingSelectors/selectBalancingRandomPools";
import { selectResourceAmountInfo } from "../balancingSelectors/selectBalancingResources";
import { selectUiDefinitionCategory } from "../balancingSelectors/selectBalancingUiDefinitions";
import { IdMenuBalancing } from "../constants/IdMenuBalancing";
import { IdModal } from "../features/modals/IdModal";
import { selectBuildingCount } from "./selectExistingBuildingInfo";
import { selectModalTabId } from "./selectModalTabId";
export var selectStoreItems = function (state) {
    var type = selectModalTabId(state, IdModal.Store);
    if (type == undefined) {
        return [];
    }
    var shopItemsCategory = selectUiDefinitionCategory(IdMenuBalancing.Store, type);
    if (shopItemsCategory == undefined) {
        return [];
    }
    // FIXME continue from here.
    return shopItemsCategory.packageItem.map(function (_a) {
        var packageId = _a.packageId;
        var balancing = selectBalancingPackageById(packageId);
        var resourceReward = balancing.resourceReward, cost = balancing.cost, buildingReward = balancing.buildingReward, randomPoolReward = balancing.randomPoolReward;
        var _b = cost[0], resourceId = _b.resourceId, amount = _b.amount;
        var costResourceInfo = selectResourceAmountInfo(resourceId, amount);
        if (resourceReward) {
            var _c = resourceReward[0], rId = _c.resourceId, amt = _c.amount;
            var purchasedResourceInfo = selectResourceAmountInfo(rId, amt);
            return {
                balancing: balancing,
                costResourceInfo: costResourceInfo,
                purchasedResourceInfo: purchasedResourceInfo,
            };
        }
        if (buildingReward) {
            var buildingId = buildingReward[0].buildingId;
            var buildingRewardInfo = selectBalancingBuilding(buildingId);
            var buildingCount = selectBuildingCount(state, buildingId);
            return {
                balancing: balancing,
                buildingCount: buildingCount,
                buildingRewardInfo: buildingRewardInfo,
                costResourceInfo: costResourceInfo,
            };
        }
        if (randomPoolReward) {
            var randomPoolRewardInfo = selectPoolRewardsIconInfo(randomPoolReward[0].randomPoolId);
            return {
                balancing: balancing,
                costResourceInfo: costResourceInfo,
                randomPoolRewardInfo: randomPoolRewardInfo,
            };
        }
        return {
            balancing: balancing,
            costResourceInfo: costResourceInfo,
        };
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectStoreItems.ts
// module id = 2766
// module chunks = 3